module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.16671/img/visitor-widget/bot-avatar.svg"